// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/checkbox-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FreemiumMain_info__25zBt {
  width: 100%;
  border: 1px dashed #00007a;
  border-radius: 12px;
  padding: 20px;
  color: #00007a;
  line-height: 1.8;
  margin-bottom: 12px;
}
.FreemiumMain_info__25zBt ul {
  padding: 0;
  margin: 0;
}
.FreemiumMain_info__25zBt ul li {
  list-style: none;
  margin-bottom: 12px;
  display: flex;
  align-items: baseline;
  font-weight: 300;
}
.FreemiumMain_info__25zBt ul li span {
  width: 20px;
  margin-right: 10px;
}
.FreemiumMain_info__25zBt ul li span svg {
  width: 20px;
  vertical-align: middle;
}
.FreemiumMain_info__25zBt ul li span svg path {
  fill: #00007a;
}
.FreemiumMain_info__25zBt p {
  text-align: center;
  font-weight: 600;
  padding: 0 20px;
}

.FreemiumMain_cards__0WeDd {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.FreemiumMain_price__59e1t {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  background: #4343ff;
  color: #fff;
}
.FreemiumMain_price-description__8RrXV {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}

.FreemiumMain_product__7mDVS {
  padding: 20px;
  border-radius: 12px;
  background: #fff;
  color: #00007a;
}
.FreemiumMain_product-title__ZOU49 {
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.FreemiumMain_product-description__XKSW7 {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}

.FreemiumMain_logo__UzLZa {
  margin-right: 8px;
}

.FreemiumMain_collapsible-card__Z2E\\+N {
  padding: 20px;
  background: #fff;
}

.FreemiumMain_list__D64MF {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  margin: 0;
  padding: 0;
}
.FreemiumMain_list-title__cZOTv {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.FreemiumMain_item__W2Dpd {
  display: flex;
  align-items: baseline;
}
.FreemiumMain_item__W2Dpd:before {
  content: "";
  display: inline-block;
  width: 17px;
  min-width: 17px;
  height: 17px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  vertical-align: top;
  transform: translateY(4px);
}

.FreemiumMain_button__ibiZ- {
  width: 240px;
}

.FreemiumMain_link__Nq6gs {
  width: 360px;
  text-align: center;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #000078;
}

@media screen and (max-width: 600px) {
  .FreemiumMain_link__Nq6gs {
    width: 100%;
    text-align: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/FreemiumMain/FreemiumMain.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,cCDS;EDET,gBAAA;EACA,mBAAA;AAIF;AAFE;EACE,UAAA;EACA,SAAA;AAIJ;AAFI;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AAIN;AAFM;EACE,WAAA;EACA,kBAAA;AAIR;AAFQ;EACE,WAAA;EACA,sBAAA;AAIV;AAFU;EACE,aCzBD;AD6BX;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBCzDS;ED0DT,WAAA;AAFF;AAIE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cCnES;ADgEX;AAKE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AALF;AAOE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC1GO;ADqGX;;AASA;EACE,aAAA;EACA,qBAAA;AANF;AAQE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AANJ;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCvIU;ADgIZ;;AAUA;EACE;IACE,WAAA;IACA,mBAAA;EAPF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.info{\n  width: 100%;\n  border: 1px dashed colors.$primary8;\n  border-radius: 12px;\n  padding: 20px;\n  color: colors.$primary8;\n  line-height: 1.8;\n  margin-bottom: 12px;\n\n  ul{\n    padding: 0;\n    margin: 0;\n\n    li{\n      list-style: none;\n      margin-bottom: 12px;\n      display: flex;\n      align-items: baseline;\n      font-weight: 300;\n\n      span{\n        width: 20px;\n        margin-right: 10px;\n\n        svg{\n          width: 20px;\n          vertical-align: middle;\n  \n          path{\n            fill: colors.$primary8;\n          }\n        }\n      }\n    }\n  }\n\n  p{\n    text-align: center;\n    font-weight: 600;\n    padding: 0 20px;\n  }\n}\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.price {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n  background: colors.$primary4;\n  color: #fff;\n\n  &-description {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n}\n\n.product {\n  padding: 20px;\n  border-radius: 12px;\n  background: #fff;\n  color: colors.$primary8;\n\n  &-title {\n    margin-bottom: 12px;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  &-description {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n  }\n}\n\n.logo {\n  margin-right: 8px;\n}\n\n.collapsible-card {\n  padding: 20px;\n  background: #fff;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  margin: 0;\n  padding: 0;\n\n  &-title {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: baseline;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    background: url(../../../assets/checkbox-circle.svg);\n    background-size: cover;\n    vertical-align: top;\n    transform: translateY(4px);\n  }\n}\n\n.button{\n  width: 240px;\n}\n\n.link {\n  width: 360px;\n  text-align: center;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: colors.$primary11;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .link {\n    width: 100%;\n    text-align: initial;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"info": `FreemiumMain_info__25zBt`,
	"cards": `FreemiumMain_cards__0WeDd`,
	"price": `FreemiumMain_price__59e1t`,
	"price-description": `FreemiumMain_price-description__8RrXV`,
	"product": `FreemiumMain_product__7mDVS`,
	"product-title": `FreemiumMain_product-title__ZOU49`,
	"product-description": `FreemiumMain_product-description__XKSW7`,
	"logo": `FreemiumMain_logo__UzLZa`,
	"collapsible-card": `FreemiumMain_collapsible-card__Z2E+N`,
	"list": `FreemiumMain_list__D64MF`,
	"list-title": `FreemiumMain_list-title__cZOTv`,
	"item": `FreemiumMain_item__W2Dpd`,
	"button": `FreemiumMain_button__ibiZ-`,
	"link": `FreemiumMain_link__Nq6gs`
};
export default ___CSS_LOADER_EXPORT___;
